import React from 'react';
import { useTranslation } from 'react-i18next';

const Loading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen page-bg flex items-center justify-center p-8">
      <div className="text-center space-y-6">
        {/* Pulsing rings */}
        <div className="relative w-20 h-20 mx-auto">
          <span className="absolute inset-0 rounded-full border-2 border-velohost-primary-300 animate-ping opacity-30" />
          <span className="absolute inset-2 rounded-full border-2 border-velohost-primary-400 animate-ping opacity-25" style={{ animationDelay: '0.35s' }} />
          <span className="absolute inset-5 rounded-full bg-velohost-primary-500 opacity-90 animate-pulse" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-slate-800">{t('loading.title')}</h2>
          <p className="text-slate-500 mt-1">{t('loading.subtitle')}</p>
        </div>
      </div>
    </div>
  );
};

export default Loading;
